import React, { ReactNode } from 'react';
import { FullReportEntry, ReportEntry } from '../../models/FullReportEntry';
import { usePastRender } from '../AccountContext';


type AccountCellRender = (entry: ReportEntry, index: number) => ReactNode

function PastCell({render, item, index}:{render: AccountCellRender, item: FullReportEntry, index:number}){
    const pastRender = usePastRender()
    
    return <>
        {render(item, index)}
        
        {(pastRender && item.past) && <small className="text-muted d-block mt-1">
            {render(item.past, index)}
        </small>}
    </>
}

export function pastMonth(render: AccountCellRender){
    return (item: FullReportEntry, index: number) => <PastCell render={render} item={item} index={index} />
}